import { render, staticRenderFns } from "./avar.vue?vue&type=template&id=cb4cfd26&scoped=true"
import script from "./avar.vue?vue&type=script&lang=js"
export * from "./avar.vue?vue&type=script&lang=js"
import style0 from "./avar.vue?vue&type=style&index=0&id=cb4cfd26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4cfd26",
  null
  
)

export default component.exports